export default "__VITE_ASSET__BrvGCb2M__"